<template>
    <div>
        <Modal
            class-name="vertical-center-modal"
            :value="showSetModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-whetherSync="openOrClose"  :styles="{'min-width':'960px'}">
            <div class="search-div flexBC">

                <div class="flexC">

                    <div class="search-div-item flexC">
                        <div class="labelText">{{$t("BasicProduct.titleName.basicClassId")}}</div>
                        <Cascader :data="basicClassIdList" v-model="basicClassIdArr" change-on-select ></Cascader>
                    </div>
                    <div class="search-div-item">
                        <Button type="info" @click="searchItem"  icon="ios-search" style="margin-top:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
                    </div>
                </div>

                 <div class="search-div-item">
                        <Button type="success" @click="modalTip=true"  :disabled="importDisabled" :loading="importLoading" style="margin-top:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('BasicProduct.funcBox.import')}}</Button>
                 </div>


            </div>
            
            <Table style="width: 100%;margin-top: 30px;" id="mytable" width="960" height="400" ref="selection" :columns="tableTitle" :data="tableData" :loading='loading' @on-selection-change="selectChange"></Table>
            <div style="visibility: hidden;">占位</div>

            <Modal
                class-name="vertical-center-modal"
                v-model="modalTip"
                title="Tip 提示"
                @on-cancel="modalTip=false"
                @on-ok="subData"
                :ok-text="$t('confirm')"
                :cancel-text="$t('cancel')"
                width="300">
                <p>确定导入该基础型号下面的所有功能吗？</p>
            </Modal>

        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import * as XLSX from 'xlsx/xlsx.mjs';
import common from '@/common/common';
import excel from '@/common/excel'
import { mapState } from 'vuex'
import {toTree} from "@/libs/tools.js"

export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            basicTypeId:Number,
            designImplType:Number,//3.通用功能、参数，1.普通，2.hex
            loraProductKey:String 
        },
        name: "ModelImport",
        components: {
        },
        data() {
            return {   
                title: '选择需要导入的基础型号',//弹框标题
                modalTip:false,
                tableData:[],
                loading:false,
                basicClassIdArr:[],
                basicClassIdList:[],
                basicClassIdList1:[],
                importDisabled:true,
                hasSelectData:{},
                importLoading:false
            }
        },

        computed:{
             ...mapState(['selectId','showChildrenSide']),
             tableTitle(){
                   return [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
         
                    {
                        title: this.$t('BasicProduct.titleName.Id'),
                        key: 'id',
                        width: 120,
                        sortable: true,
                    },
                    {
                        title: this.$t('BasicProduct.titleName.basicName'),
                        key: 'basicName',
                        width: 220,
                        sortable: true,
                        resizable: true,
                        render:(h, params)=>{
                            let stext = params.row.basicName
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                  
                    {
                        title: this.$t('BasicProduct.titleName.comMode'),
                        key: 'comMode',
                        width: 190,
                        render:(h, params)=>{
                            let stext = '' 
                            let comModeList = {'1':'BLE','2':'WIFI','3':'LORADTU','4':'LORAWan','5':'BLEMesh','6':'BLE5','7':'4GCat1','8':'RS485','30':"other"}
                            let nameFlag = comModeList[params.row.comMode]
                            

                            if(!nameFlag){
                                stext =params.row.comMode
                            }else{
                                stext =this.$t('selectList.comModeListBasic.'+nameFlag) 
                            }

                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('BasicProduct.titleName.loraProductKey'),
                        key: 'loraProductKey',
                        minWidth: 220,
                        render:(h, params)=>{
                            let loraProductKey = ['A6k_t3Rng','u_ElpqR7R','HJTutqgnR','aYFrpqg7g','None']
                            let nameFlag = loraProductKey.indexOf(params.row.loraProductKey)
                            let stext = ''
                            if(nameFlag<0){
                                stext =params.row.loraProductKey
                            }else{
                                stext =this.$t('selectList.loraProductKeyBasic.'+params.row.loraProductKey) 
                            }
                            // console.log('name',nameFlag)
              
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    }
                ]
             }

        },
        created(){
        },
        mounted(){
        },
        watch:{
            showSetModel(val){
                if(val){
                    this.getCate()
                    this.getData()
                }else{
                    this.resetForm();//重置表单
                }
            }
        },
        methods: {
            openOrClose(value) {
                if(value === false) {
                   this.resetForm();//重置表单

                }
            },
             searchItem(){//搜索
               this.loading = true
               this.getData()
            },
            async getCate(){//获取全部分类数据
                 let res = await this.axios.post(this.config.urlArray.typeCateList, {parentClassId:null})
                 common.ajaxMsg(res.data,false,()=>{
                    this.basicClassIdList1 = res.data.data
                    this.basicClassIdList = toTree(this.basicClassIdList1)
                 },()=>{

                 })

            },
            getData(){ //获取数据
                 this.loading = true
                let cid = this.basicClassIdArr[this.basicClassIdArr.length-1] || ''
                let params ={
                        basicClassId:cid,
                        designImplType:this.designImplType
                    }
                    // if(this.loraProductKey){
                    //     delete params.designImplType
                    // }
                this.axios.post(this.config.urlArray.typeList,params).then((result) => {
                    let resData = result.data.data
                    common.ajaxMsg(result.data,false,()=>{

                        //处理数组
                        if(resData){
                            
                            this.tableData = resData.map((item)=>{
                                if(item.id==this.basicTypeId){
                                    item._disabled = true
                                }

                                return item

                            })

                            if(this.loraProductKey){
                                this.tableData = this.tableData.filter( (obj)=> {
                                    return obj.loraProductKey == this.loraProductKey; // 这里只保留年龄为 20 的对象
                                });
                            }



                            this.loading = false
                        }else{
                            return false
                        }
                    });
                    
                })
            },
            clearbtnStatus() { //清空编辑数据 与按钮状态
                this.importDisabled = true
                this.hasSelectData = {}
                
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                if(res.length == 1){
                    this.importDisabled = false
                    this.hasSelectData = res[0]
                }else{
                    this.clearbtnStatus()
                }
            },
            subData() {//提交表单

          
                let params = {
                    basicTypeId:this.basicTypeId,
                    copySourceBasicTypeId:this.hasSelectData.id
                }

                // if(this.basicTypeId==this.hasSelectData.id){
                //     this.$Message.error('不能复制自己')
                //     return
                // }
  
                this.importDisabled = true;
                this.importLoading = true;
                // console.log('params',params)
                // console.log('params1',this.hasSelectData)
                this.axios.post(this.config.urlArray.copyBasicProduct, params).then((result) => {
                    
                    common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        
                        this.$refs.selection.selectAll(false);
                        this.resetForm();//重置表单
                        this.fn(1)
                        this.importLoading = false;
                        
                    },()=>{
                        this.importDisabled = false;
                        this.importLoading = false;
                    })
                    
                    
                })

            },
            cancel() {//对话框关闭
                this.fn(0)
                this.resetForm();//重置表单
            },
            resetForm() {//重置表单
                this.clearbtnStatus();
                this.tableData=[];
                this.basicClassIdArr=[];
               
            }
        }
}
</script>
<style lang='less' scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}

.changeBox{
    /deep/ .ivu-form-item-content{
         margin-left: 0 !important;
         text-align: center;

    }
   
}
.search-div{
     flex-wrap: wrap;
     background-color: #fff;
    //  padding: 34px 40px ;
     background: #FFFFFF;
     margin: 20px 0px 30px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
         height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-cascader{
         height: 54px;
         line-height: 54px;
     }
     .labelText{
        line-height: 54px;
        height: 54px;
        flex-shrink: 0;
        margin-right: 10px;
    }
 }


</style>
